var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ecommerce",
    transform: "translate(-649.000000, -5888.000000)",
    fill: "#86939E"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cart-#1-Copy",
    transform: "translate(150.000000, 5772.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "#1",
    transform: "translate(30.000000, 81.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "QTY",
    transform: "translate(459.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,14 L10,14 L10,16 L14,16 L14,20 L16,20 L16,16 L20,16 L20,14 L16,14 L16,10 L14,10 L14,14 Z",
    id: "Icon"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.9c70d34e13ed77728b9e679e67a15161.svg";
export { ForwardRef as ReactComponent };